module.exports = __webpack_public_path__ + "static/img/weather-bg-15.4ba979a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather/weather-bg-15.gif
// module id = udma
// module chunks = 1